import Close from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import TimesheetStatusChip from '../TimesheetStatusChip';

interface DrawerHeaderProps {
  isProcessing: boolean;
  onClose: () => void;
  sx?: SxProps<Theme>;
}

export default function DrawerHeader({ isProcessing, onClose, sx }: DrawerHeaderProps) {
  return (
    <Box
      sx={[
        (theme) => ({
          alignItems: 'center',
          borderBottom: `solid 1px ${theme.palette.divider}`,
          display: 'flex',
          justifyContent: 'space-between',
          px: 3,
          py: 2,
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Box sx={{ alignItems: 'center', display: 'flex', gap: 1.5 }}>
        <Typography
          sx={(theme) => ({
            color: theme.brandV2.colors.treadBlack,
            fontSize: '18px',
            fontWeight: 600,
          })}
        >
          {t('approvals.timesheets.drawer_title')}
        </Typography>
        {isProcessing && <TimesheetStatusChip aiProcessed={false} />}
      </Box>

      <IconButton
        aria-label={t('actions.close')}
        color="inherit"
        onClick={onClose}
        size="small"
      >
        <Close sx={{ height: 16, width: 16 }} />
      </IconButton>
    </Box>
  );
}
